
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetopandharpur() {



    const cardData =
    {
        keyword: 'Pune To Pandharpur Cab Booking',
        heading: 'Mauli Cabs:  Pune To Pandharpur Cab Booking',
        headingDescription: 'Mauli Cabs offers easy and dependable Pune to Pandharpur cab booking services, ensuring a smooth and comfortable journey to this sacred destination. Whether you are traveling for a pilgrimage, a family visit, or a peaceful retreat, we provide a range of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a focus on safety, Mauli Cabs guarantees a hassle-free travel experience from Pune to Pandharpur.',

        top: 'Top Places to Visit in Pandharpur with Mauli Cabs',

"topPlaces": [
    {
        "title": "Vitthal Rukmini Temple",
        "description": "The Vitthal Rukmini Temple is the spiritual heart of Pandharpur, dedicated to Lord Vitthal (an incarnation of Lord Krishna) and Goddess Rukmini. It's a major pilgrimage center attracting devotees from all over India."
    },
    {
        "title": "Chandrabhaga River",
        "description": "The holy Chandrabhaga River, which curves like a crescent moon, is considered sacred by devotees. Pilgrims often take a holy dip here before visiting the Vitthal Temple."
    },
    {
        "title": "Pundalik Temple",
        "description": "The Pundalik Temple honors the legendary devotee Pundalik, whose devotion is believed to have brought Lord Vitthal to Pandharpur. The temple is an important religious site for visitors."
    },
    {
        "title": "Gopalpur",
        "description": "Located a few kilometers from Pandharpur, Gopalpur is associated with Lord Krishna and is known for its beautiful natural surroundings and religious significance."
    },
    {
        "title": "Kaikadi Maharaj Math",
        "description": "This math (monastery) is a fascinating spiritual center showcasing stories from Hindu mythology through colorful and detailed sculptures. It's an educational and cultural experience for visitors."
    },
    {
        "title": "ISCON Pandharpur",
        "description": "The ISKCON temple in Pandharpur offers a peaceful and well-maintained space for devotees to chant, meditate, and participate in bhajans (devotional songs) dedicated to Lord Krishna."
    },
    {
        "title": "Mangalwedha",
        "description": "Known as the 'Land of Saints,' Mangalwedha is near Pandharpur and is associated with many saints of the Bhakti movement. It’s a great place to explore spiritual heritage."
    },
    {
        "title": "Siddheshwar Temple, Machnur",
        "description": "Situated near Pandharpur, this ancient temple dedicated to Lord Siddheshwar attracts devotees and features impressive stone architecture."
    },
    {
        "title": "Vithoba Museum",
        "description": "The Vithoba Museum showcases artifacts, paintings, and scriptures related to the history and culture of Pandharpur and the worship of Lord Vitthal."
    },
    {
        "title": "Bhima River Ghat",
        "description": "Apart from Chandrabhaga, the Bhima River has scenic ghats in the surrounding areas where pilgrims gather for rituals, prayers, and to enjoy the tranquil environment."
    }
],

"services": [
    {
        "name": "Pune to Pandharpur Cab Service",
        "description": "Mauli Cabs offers reliable cab services from Pune to Pandharpur, ideal for pilgrimages and personal visits. Enjoy a smooth and spiritual journey with our experienced drivers."
    },
    {
        "name": "Book Pune to Pandharpur Taxi",
        "description": "Book your taxi from Pune to Pandharpur with Mauli Cabs for a hassle-free and comfortable experience. Choose from a variety of vehicle options to suit your needs."
    },
    {
        "name": "Affordable Pune to Pandharpur Cab",
        "description": "Mauli Cabs provides affordable taxi options from Pune to Pandharpur. Travel in comfort without stretching your budget on your pilgrimage or personal visit."
    },
    {
        "name": "Private Taxi for Pandharpur from Pune",
        "description": "Choose Mauli Cabs for private taxi service from Pune to Pandharpur. Ideal for peaceful, personalized travel with flexible scheduling and privacy."
    },
    {
        "name": "Pandharpur Pilgrimage Taxi from Pune",
        "description": "Planning a pilgrimage to Pandharpur? Mauli Cabs offers comfortable and reliable taxi services tailored for spiritual journeys from Pune."
    },
    {
        "name": "Pune to Pandharpur One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip options for your Pune to Pandharpur journey. Book as per your convenience and travel with ease."
    },
    {
        "name": "Pandharpur Temple Tour by Taxi",
        "description": "Explore the sacred town of Pandharpur with Mauli Cabs. Our drivers are familiar with the key temples and ensure a smooth and devotional tour experience."
    },
    {
        "name": "Group Travel to Pandharpur",
        "description": "Traveling in a group to Pandharpur? Mauli Cabs offers spacious vehicles perfect for group pilgrimages or family visits with comfort and coordination."
    },
    {
        "name": "Comfortable Taxi from Pune to Pandharpur",
        "description": "Mauli Cabs ensures a comfortable and safe ride from Pune to Pandharpur. Enjoy clean, air-conditioned vehicles and courteous service."
    },
    {
        "name": "Pandharpur Visit by Private Cab",
        "description": "Plan your visit to Pandharpur with Mauli Cabs’ private cab service. A convenient option for those seeking a relaxed and personal travel experience."
    }
],

"tableData": [
    ["Pune to Pandharpur Cab Service", "Book Pune to Pandharpur Taxi"],
    ["Affordable Pune to Pandharpur Cab", "Private Taxi for Pandharpur from Pune"],
    ["Pandharpur Pilgrimage Taxi from Pune", "Pune to Pandharpur One-Way or Round Trip"],
    ["Pandharpur Temple Tour by Taxi", "Group Travel to Pandharpur"],
    ["Comfortable Taxi from Pune to Pandharpur", "Pandharpur Visit by Private Cab"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers dependable and punctual Pune to Pandharpur Cab Booking services. Whether you're heading for a spiritual visit or a peaceful journey, our drivers ensure timely pickups and drop-offs, so you can reach Pandharpur without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet includes sedans, SUVs, and premium vehicles, all designed for your comfort. Enjoy a relaxing Pune to Pandharpur ride with air-conditioned, clean, and spacious cabs that offer plenty of legroom and smooth travel across long distances."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the Pune to Pandharpur route. They follow the safest and most efficient paths, ensuring a smooth, respectful, and secure journey to one of Maharashtra’s most revered pilgrimage destinations."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers budget-friendly and transparent pricing for your Pune to Pandharpur Cab Booking. With no hidden charges and competitive rates, you get great value for your money while enjoying reliable and quality service."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All Mauli Cabs vehicles are regularly inspected and fitted with safety essentials like seat belts, airbags, and GPS tracking. Our drivers strictly adhere to road safety norms to provide a peaceful and secure travel experience."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you're planning an early morning start or a late-night return, Mauli Cabs is available 24/7 for Pune to Pandharpur Cab Booking. Our support team is always ready to help you with flexible scheduling and prompt assistance."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Pandharpur cab with Mauli Cabs is easy and convenient. Use our website or mobile app to book instantly, or call our customer service team for help. We make sure your booking process is smooth from start to finish."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're visiting for a pilgrimage, family outing, or a spiritual retreat, Mauli Cabs offers tailored travel packages for Pune to Pandharpur Cab Booking. Let us know your requirements, and we’ll plan the perfect ride for your journey."
    }
]









    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Pandharpur with Mauli Cabs?',
            answer: 'Booking your cab is easy! You can use our website or mobile app to book. Just enter Pune as your pickup location and Pandharpur as your destination, then select the vehicle that suits your needs. You can also call our customer support for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Pandharpur?',
            answer: 'Mauli Cabs provides a range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Pick the one that best suits your comfort and passenger capacity requirements.',
        },
        {
            question: 'Is the fare from Pune to Pandharpur fixed?',
            answer: 'Yes, our fares are fixed and transparent. The price includes tolls, taxes, and driver charges—no hidden fees, and you’ll know the total amount before you travel.',
        },
        {
            question: 'Can I book a round trip from Pune to Pandharpur?',
            answer: 'Absolutely! You can book both one-way and round trips. Just mention your return trip details during booking and we’ll handle the rest.',
        },
        {
            question: 'How long does the journey from Pune to Pandharpur take?',
            answer: 'The trip from Pune to Pandharpur typically takes around 4.5 to 5.5 hours, depending on traffic and road conditions. Our drivers ensure a smooth and timely journey.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Pandharpur route?',
            answer: 'Yes, all Mauli Cabs drivers are experienced, professional, and familiar with the Pune to Pandharpur route. You can expect a safe and stress-free journey.',
        },
        {
            question: 'Can I book a cab for temple visits and local travel in Pandharpur?',
            answer: 'Yes, we offer customized packages for temple visits and local travel within Pandharpur. Just let us know your itinerary when booking.',
        },
        {
            question: 'Are your cabs air-conditioned and comfortable?',
            answer: 'Definitely! All our cabs are well-maintained, clean, and air-conditioned to ensure maximum comfort for your journey.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, we have a flexible cancellation and modification policy. You can make changes via our website or app, or get in touch with our support team for help.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Pandharpur trip?',
            answer: 'Mauli Cabs offers dependable service, affordable pricing, a variety of vehicles, and courteous drivers. We’re dedicated to making your spiritual journey to Pandharpur peaceful and convenient.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Suresh Kulkarni",
            position: "Devotee",
            text: "The journey to Pandharpur was peaceful and comfortable. The driver was respectful and knew the route well. Thank you Mauli Cabs for making our pilgrimage smooth and timely.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Aarti Desai",
            position: "Solo Traveler",
            text: "Traveling alone to Pandharpur felt safe and stress-free with Mauli Cabs. The cab was clean, on time, and the driver was extremely professional. Highly recommended for spiritual trips!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Pandharpur Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs provides reliable and affordable cab services from Pune to Pandharpur for pilgrimages or casual visits. Choose private, luxury, or group taxis for a comfortable one-way or round-trip journey with 24x7 online booking.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4500"
        }
      };
      
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Pandharpur Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Pandharpur cab with Mauli Cabs. Affordable private, group, and luxury taxi options for pilgrimage or sightseeing. One-way and round-trip booking available 24x7."
        />
        <meta
          name="keywords"
          content="Pune to Pandharpur cab service, Book Pune to Pandharpur taxi, Affordable Pune to Pandharpur cab, Private taxi for Pandharpur from Pune, Pandharpur pilgrimage taxi from Pune, Pune to Pandharpur one-way or round trip, Pandharpur temple tour by taxi, Group travel to Pandharpur, Comfortable taxi from Pune to Pandharpur, Pandharpur visit by private cab"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopandharpur;